import React from 'react';

class BackToTop extends React.Component {

    constructor(props) {
        super(props);
        this.run = this.run.bind(this);
    }

    run(){
        const doc = document.documentElement;
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

        if (top > 0) {
            window.scrollTo(0, top - 15);
            setTimeout(this.run, 10);
        }
    }

    render(){
        return (
            <div id="to-top">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-md-6 col-lg-4">
                        <button onClick={this.run} className="btn btn-outline-secondary btn-block back-to-top"><span className="triangle" /> Back to top <span className="triangle" /></button>
                    </div>
                </div>
            </div>
        );
    }
}

export default BackToTop;



// WEBPACK FOOTER //
// ./src/components/chunks/BackToTop.js